import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './troy.module.scss';

const Logo = props => {
  return (
    <img
      src={props.src}
      alt="troy-logo"
      className={classNames(props.className, styles['logo'])}
    />
  );
};

Logo.propTypes = {
  src: PropTypes.string,
  initialSize: PropTypes.bool
};

export default Logo;
